import {Component, OnInit, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';

import {AlertaEnum, DialogoEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';

import {ColaboradorEstudio} from '@modelo/catalogo/ColaboradorEstudio.model';

@Component(
    {
        selector: 'colaborador_estudio',
        templateUrl: './colaborador_estudio.template.html',
        styleUrls: ['../colaborador.component.scss']
    })

export class ColaboradorEstudioComponent implements OnInit {
    @Input() id!: number;
    @Input() disabled!: boolean;

    public entidad: ColaboradorEstudio;

    SelEscolaridad: any[];
    SelEstatusEstudio: any[];

    public abierto!: boolean;
    public animacion!: string;
    public errorActivo!: boolean;

    dataTable: Array<any>;

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService) {
        this.entidad = new ColaboradorEstudio();

        this.SelEscolaridad = [];
        this.SelEstatusEstudio = [];

        this.dataTable = [];
    }

    ngOnInit() {
        this.setEscolaridad();
        this.setEstatusEstudio();

        this.Buscar();
    }


    setEscolaridad() {
        this.appService.Get("catalogo/escolaridad").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelEscolaridad = res.data
            }
        });
    }
    setEstatusEstudio() {
        this.appService.Get("catalogo/estatusestudio").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelEstatusEstudio = res.data
            }
        });
    }

    Editar(e: ColaboradorEstudio) {
        this.entidad = Object.assign({}, e);
        this.Modal();
    }

    Modal() {
        this.animacion = this.sistemaService.animacionAbirModal;
        this.abierto = true;
        this.errorActivo = false;
    }

    CerrarModal() {
        this.entidad = new ColaboradorEstudio();
        this.animacion = this.sistemaService.animacionCerrarModal;

        setTimeout(() => {
            this.abierto = false;
        }, 310);
    }

    Guardar(): Promise<any> {
        return new Promise((resolve, reject) => {
            let respuesta = this.Validar();
            if (respuesta != true) {
                return this.mensajeService.Alerta(AlertaEnum.Warning, respuesta);
            }


            let data = new ColaboradorEstudio(this.entidad);
            this.appService.Post("configuracionrh/colaborador/estudio/" + this.id, data).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                    this.CerrarModal();
                    this.Buscar();
                }
            })
        })
    }

    Validar(): any {
        this.errorActivo = true;
        if (!this.entidad.escolaridadid) {
            return "Ingrese un nivel de estudios";
        }

        if (!this.entidad.titulo || !this.entidad.titulo.trim()) {
            return "Ingrese un título";
        }
        if (!this.entidad.institucioneducativa || !this.entidad.institucioneducativa.trim()) {
            return "Ingrese una institución educativa";
        }

        if (!this.entidad.estatusestudioid) {
            return "Ingrese un estatus";
        }
        return true;
    }

    Buscar() {
        this.appService.Get("configuracionrh/colaborador/estudio/" + this.id).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.dataTable = res.data;
            }
        })
    }

    Eliminar(e: ColaboradorEstudio) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                this.appService.Delete("configuracionrh/colaborador/estudio/" + e.colaboradorestudioid).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.Buscar();
                    }
                })
            }
        })
    }

}
